<template>
	<div id="app">
		<router-view />
	</div>
</template>
<script>
	import Cookies from 'js-cookie'
	export default {
		mounted() {
			// const decoder = new TextDecoder('utf-8');
			// 发出请求
			// fetch('https://fonts.googleapis.com/css?family=123')
			// 	.then(response => {
			// 		const reader = response.body.getReader();
			// 		console.log('response',response)
			// 		return reader.read().then(function process({
			// 			done,
			// 			value
			// 		}) {
			// 			if (done) {
			// 				console.log('Stream finished');
			// 				return;
			// 			}
			// 			// 解码数据
			// 			const text = decoder.decode(value);
			// 			console.log('Received text chunk', text);
			// 			var style = document.createElement('style');
			// 			style.type = 'text/css';
			// 			style.innerHTML = text;
			// 			document.getElementsByTagName('HEAD').item(0).appendChild(style);
			// 			return reader.read().then(process);
			// 		});
			// 	})
			// 	.catch((e)=>{
			// 		console.log('e',e)
			// 	});
			// console.log('process', process.env)
			if (process.env.NODE_ENV == 'development') {
				if(!Cookies.get('wsid')) {
					Cookies.set('login', '');
					Cookies.set('wsid', '');
					Cookies.set('weimei_session', '');
					Cookies.set('XSRF-TOKEN', '');
				}
			}

		}
	}
</script>
<style lang="scss">
	
	body {
		margin: 0;
		font-family: Arial, sans-serif;
		background-color: #f5f5f5;
	}

	// @import url("assets/scss/_globals.scss");
	::-webkit-scrollbar {
		display: none;
	}

	scrollbar-hidden {
		scrollbar-width: none;
	}

	scrollbar-hidden {
		-ms-overflow-style: none;
	}

	scrollbar-hidden::-webkit-scrollbar {
		display: none;
	}

	scrollbar-hidden {
		overflow-x: hidden;
		overflow-y: auto;
	}

	#app {
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		padding: 0px;
		margin: 0px;
	}
</style>